import { Alert, Box, Button, Chip, CircularProgress, Stack, Typography } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import { useTranslation } from 'react-i18next';
import { COMMUNICATION_CHANNELS } from '../utils/spaCommunications';

export default function SpaCommunicationChannels({ state }) {
  const { t } = useTranslation();
  const ct = (key, options) => t(`spa.communications.${key}`, options);
  return <Box>
    {state.loading && <CircularProgress size={20} aria-label={ct('readinessLoading')} />}
    {state.error && <Alert severity="error" action={<Button color="inherit" onClick={state.refresh}>{ct('retry')}</Button>}>
      {ct('readinessError')} {state.error}</Alert>}
    {state.data && <Stack spacing={1}>
      <Stack direction="row" flexWrap="wrap" gap={1} alignItems="center">
        {COMMUNICATION_CHANNELS.map((channel) => <Chip key={channel} size="small"
          color={state.data.channels[channel].ready ? 'success' : 'warning'}
          label={`${ct(`channels.${channel}`)}: ${ct(state.data.channels[channel].ready ? 'providerReady' : 'providerUnavailable')}`} />)}
        <Button size="small" startIcon={<RefreshIcon />} onClick={state.refresh}>{ct('refresh')}</Button>
      </Stack>
      {COMMUNICATION_CHANNELS.filter((channel) => !state.data.channels[channel].ready).map((channel) =>
        <Typography key={channel} variant="body2" color="text.secondary">
          {ct(`channels.${channel}`)}: {ct(`reasons.${state.data.channels[channel].reason}`, { defaultValue: state.data.channels[channel].reason || ct('providerUnavailable') })}
        </Typography>)}
      <Typography variant="caption" color="text.secondary">{ct('timeZone')}: {state.data.timeZone}</Typography>
    </Stack>}
  </Box>;
}
